import 'select2';
import 'select2/dist/css/select2';
import CalendarSchedulesController from './calendar_schedules_controller';
import sweet_alert from '../entrypoints/src/admin/utilities/sweet_alert';


export default class extends CalendarSchedulesController {
  static targets = [
    'scheduleModalMask',
    'form',
    'agenda',
    'selectProfessor',
    'scheduleAttributes',
    'scheduleProfessor',
    'modalEditActions',
    'scheduleAttendanceForm',
    'inputDate'
  ];

  connect() {
    this.formTarget.dataset.controller = 'student-calendar-iteractive';
    this.formTarget.dataset.studentCalendarIteractiveTarget = 'form';
    this.formTarget.insertAdjacentHTML('afterBegin', `<input type='hidden' value="${this.element.dataset.date}" name="date" data-student-calendar-iteractive-target="inputDate" />`);
    this.hasInputDateTarget && this.inputDateTarget.remove();

    $('.side-panel .select2').select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: true,
      width: 'resolve',
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal .modal-body')
    });

    this.element.querySelectorAll('.table-row .table-cell').forEach(($tableCell) => {
      $tableCell.addEventListener('click', (ev) => {
        ev.target.classList.contains('table-cell-container') && this.prepareToSelectSchedule($tableCell);
      });
    });

    [this.scheduleModalMaskTarget.querySelector('.modal-actions span.close-action'), this.scheduleModalMaskTarget].forEach(($el) => $el.addEventListener('click', (ev) => this.closeScheduleModal(ev)));
  }

  prepareToSelectSchedule($cell) {
    if (!this.canOpenToSelectSchedule($cell))
      return;

    this.selectedSchedule = {
      startTime: $cell.dataset.startTime,
      endTime: $cell.dataset.endTime,
      dayName: $cell.dataset.dayName,
      dayShort: $cell.dataset.dayShort,
      weekDay: $cell.dataset.dayIndex,
      date: $cell.dataset.date,
      professorId: this.selectProfessorTarget.value
    };
    this.selectedCard = this.insertDraftSchedule($cell);
    this.selectedCard.addEventListener('click', (ev) => this.openCard(ev.currentTarget));
    this.modalEditActionsTarget.classList.add('hidden');
    setTimeout(() => this.openModalSchedule(), 100) // wait animations end
  }

  openCard($card) {
    this.selectedCard = $card;
    this.selectedSchedule = $card.schedule;
    this.modalEditActionsTarget.classList.remove('hidden');
    setTimeout(() => this.openModalSchedule(), 200);
  }

  canOpenToSelectSchedule($cell) {
    let [year, month, date] = $cell.dataset.date.split('-'),
      [hour, minute] = $cell.dataset.startTime.split(':'),
      cellDate = new Date(+year, (+month - 1), +date, +hour, +minute),
      tableCellContainer = $cell.querySelector('.table-cell-container');

    if (!!tableCellContainer && tableCellContainer.classList.contains('not-available')) {
      return sweet_alert.fire({
        title: 'Atenção',
        html: 'Horário indisponível para check-in',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }) && false;
    }

    if(cellDate < new Date()) {
      return sweet_alert.fire({
        title: 'Atenção',
        html: 'Permitido realizar o check-in apenas para datas futuras',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }) && false;
    }

    if (this.formTarget.dataset.lockConfirmation === 'true') {
      return sweet_alert.fire({
        title: 'Atenção',
        html: 'Regularize o contrato com a empresa para realizar o check-in',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }) && false;
    }

    if (this.formTarget.dataset.inValidFrequencyCount === 'true') {
      return sweet_alert.fire({
        title: 'Atenção',
        html: 'Todas as aulas dessa semana já foram confirmadas',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }) && false;
    }

    if (this.formTarget.dataset.inValidPeriod === 'true') {
      return sweet_alert.fire({
        title: 'Atenção',
        html: 'Infelizmente você não possui permissão para realizar o check-in',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }) && false;
    }

    return true;
  }

  insertDraftSchedule($cell) {
    return this.insertCard($cell, 'open draft');
  }

  insertCard($cell, cssStyle) {
    let uid = `id-${new Date().getTime() + Math.ceil(Math.random() * 10)}`;

    $cell.querySelector('.table-cell-container').insertAdjacentHTML('beforeEnd', `
      <div class="card selected-schedule ${cssStyle}" id="${uid}">
        <div class="content">
          <div class="content-container">
            <div class="line-clamp-1 title">Check-in</div>
            <div class="time">${$cell.dataset.startTime} às ${$cell.dataset.endTime}</div>
          </div>
        </div>
      </div>
    `);

    return $cell.querySelector(`#${uid}`);
  }

  openModalSchedule() {
    this.prepareScheduleFields();
    this.prepareModalToAnimation();
    this.scheduleModalMaskTarget.classList.add('show');
    document.querySelector('.schedule-mask').style.removeProperty('z-index');
  }

  prepareScheduleFields() {
    this.scheduleAttributesTarget.querySelector('.week-day-name').innerHTML = this.selectedSchedule.dayShort;
    this.scheduleAttributesTarget.querySelector('input[name="date"]').value = this.selectedSchedule.date;
    this.scheduleAttributesTarget.querySelector('input[name="start_time"]').value = this.selectedSchedule.startTime;
    this.scheduleAttributesTarget.querySelector('input[name="end_time"]').value = this.selectedSchedule.endTime;
    this.scheduleProfessorTarget.innerHTML = this.selectProfessorTarget.selectedOptions[0].innerHTML;
    this.hasSelectLocationTarget && (this.scheduleLocationTarget.innerHTML = (+this.selectLocationTarget.value > 0 ? this.selectLocationTarget.selectedOptions[0].innerHTML : '-'));
  }

  scheduleAttendance() {
    let action = this.scheduleAttendanceFormTarget.getAttribute('action');
    action = action.replaceAll('required-date', this.selectedSchedule.date);
    this.scheduleAttendanceFormTarget.insertAdjacentHTML('afterBegin', `<input type='hidden' value="${this.selectedSchedule.professorId}" name="professor_id" />`);
    this.scheduleAttendanceFormTarget.setAttribute('action', action);
    this.scheduleAttendanceFormTarget.submit();
  }
}